import AbstractModel from '../models/AbstractModel';


export class Address extends AbstractModel {
    //#region Instance Code
        constructor(source) { super(source) }


        street()        { return this.source.strasse }
        number()        { return this.source.hausnummer }
        postcode()      { return this.source.plz }
        city()          { return this.source.ort }
    //#endregion Instance Code


    //#region Static Methods
        static create(source) { return new Address(source) }
    //#endregion Static Methods
}